import { dataHeart } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeart = /*#__PURE__*/createIcon(dataHeart)
export default IconHeart
